import React from "react";
import api from "../../../../../api";
import "../../../../Grid/grid.css";
import { Segment, Table, Message } from "semantic-ui-react";
import { Form } from "formsy-semantic-ui-react";
import { DatatableTable } from "./DatatableTable";
import { DatatableFilter } from "./DatatableFilter";
import DialogBoxDetail from "./DialogBoxDetail";
import { DatatableRow } from "./DatatableRow";

const tableHeader = [
  {
    title: "Actions",
    width: "1",
    sort: "",
  },
  {
    title: "Name",
    width: "2",
    sort: "name",
  },
  {
    title: "Email",
    width: "3",
    sort: "email",
  },
];
const queryParams = ["_limit", "_order", "_sort", "q", "_page"];

export default class DatatableList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lists: [],
      _sort: "user_id",
      _page: 1,
      _order: "desc",
      _limit: 10,
      q: "",
      totalCount: 0,
      loading: false,
      modalstatus: false,
      modaltitle: null,
      modalbuttonmsg: {},
      modalType: null,
      datatableRows: null,
      modaldata: {},
      modalmessage: "",
      updateAction: false,
      messageDisplay: "none",
    };
  }

  componentDidMount() {
    this.setState(
      {
        datatableRows: this.renderEmptyTableRows(),
      },
      () => {
        this.loadData({});
      }
    );
  }

  renderEmptyTableRows = () => (
    <Table.Row>
      <Table.Cell colSpan={7} textAlign="center">
        No record found.
      </Table.Cell>
    </Table.Row>
  );

  applyListData = (data, params) => {
    const listData = data && data.data ? data.data : null;
    let datatableRowstemp;

    if (listData && listData.totalrecord) {
      datatableRowstemp = listData.list.map((list, index) => (
        <DatatableRow
          key={index}
          list={list}
          deletePerformanceAlertMember={this.deletePerformanceAlertMember}
          editMember={this.editMember}
        />
      ));
    } else {
      datatableRowstemp = this.renderEmptyTableRows();
    }

    const newState = Object.assign({}, this.state, params, {
      datatableRows: datatableRowstemp,
      totalCount: listData && listData.totalrecord ? listData.totalrecord : 0,
      lists: listData && listData.list ? listData.list : [],
      loading: false,
    });
    this.setState(newState);
  };

  static directionConverter(order) {
    if (order === "asc") {
      return "ascending";
    } else if (order === "desc") {
      return "descending";
    } else {
      return null;
    }
  }

  handleSort = (clickedColumn) => {
    const { _sort, _order } = this.state;

    let newOrder = _order === "asc" ? "desc" : "asc";
    if (_sort !== clickedColumn) {
      newOrder = "asc";
    }

    this.loadData({
      _sort: clickedColumn,
      _page: 1,
      _order: newOrder,
    });
  };

  onChangeLimit = (event, data) => {
    if (data.value !== this.state._limit) {
      this.loadData({ _limit: data.value, _page: 1 });
    }
  };

  onSubmitFilter = (filter) => {
    if (filter !== this.state.q) {
      this.loadData({ q: filter, _page: 1 });
    }
  };

  onChangePage = (event, data) => {
    const { activePage } = data;
    if (activePage !== this.state._page) {
      this.loadData({ _page: activePage });
    }
  };

  modalbuttofun = (data) => {
    if (data.modalType == "Delete") {
      this.onDeletePerformanceAlertMember();
    }
  };

  deletePerformanceAlertMember = (id) => {
    let recordlist = this.state.lists.findIndex((list) => list.id === id);
    let modaldata = this.state.lists[recordlist];
    this.setState({
      modalstatus: true,
      modaltitle: "Confirm your action",
      modalmessage: "Are you sure you want to delete?",
      modalbuttonmsg: { submit: "Yes", cancel: "No" },
      modalType: "Delete",
      modaldata: modaldata,
      updateAction: false,
    });
  };

  modalClose = () => {
    this.setState({
      modalstatus: false,
      modaltitle: "",
      modalmessage: "",
      modalbuttonmsg: {},
      modalType: "",
      modaldata: {},
      updateAction: false,
    });
  };

  onDeletePerformanceAlertMember = () => {
    this.setState({ modalFormLoader: true });
    api.manageUser
      .deletePerformanceAlertListMember({
        id: this.state.modaldata.id,
        table: this.state.modaldata.table,
      })
      .then((data) => {
        this.setState({ modalFormLoader: false });
        try {
          let recordDeleted = this.state.lists.findIndex(
            (list) => list.id === data.data.id
          );
          let oldArr = this.state.lists;
          oldArr.splice(recordDeleted, 1);
          this.setState({
            modalstatus: false,
            modaltitle: "",
            modalmessage: "",
            modalbuttonmsg: {},
            modalType: "",
          });

          this.setState({
            loading: "none",
            message2: "block",
            color2: "green",
            msg2: "Performance alert notification member has been deleted successfully.",
          });
          this.props.UpdateToasterMsgThree(this.state);
          this.loadData({});
        } catch (err) {
          console.log(err);
        }
      });
  };

  loadData = (params) => {
    const newState = Object.assign({}, this.state, params, { loading: false });
    queryParams.forEach(function (element) {
      if (!(element in params)) {
        params[element] = newState[element];
      }
    });

    const esc = encodeURIComponent;
    const query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");

    this.setState(newState, () => {
      this.setState({ loading: true });
      api.manageUser
        .getPerformanceAlertLists(query)
        .then((data) => {
          this.applyListData(data, params);
        })
        .catch((err) => {
          console.log(err);
          this.applyListData(null, params);
        });
    });
  };

  editMember = (id) => {
    this.setState({ loading: true });
    let recordlist = this.state.lists.findIndex((list) => list.id === id);
    let modaldata = { ...this.state.lists[recordlist] };
    modaldata.existing_email = modaldata.email;
    this.setState(
      {
        modaldata: modaldata,
        modalbuttonmsg: { submit: "Submit", cancel: "Close" },
        modalstatus: true,
        modaltitle: "Edit notification member details",
        modalType: "",
        loading: false,
        updateAction: true,
      },
      () => {
        this.setState({
          modalmessage: this.memberEditBody(),
        });
      }
    );
  };

  onchangeenable = (e) => {
    const memberData = this.state.modaldata;
    memberData[e.target.name] = e.target.value;
    this.setState(
      {
        modaldata: memberData,
      },
      () => {
        this.setState({
          modalmessage: this.memberEditBody(),
        });
      }
    );
  };

  memberEditBody = () => {
    const errorLabel = <div className="red" />;
    return (
      <div className="col-md-12">
        <Message
          color={this.state.color}
          style={{
            display: this.state.messageDisplay,
          }}
        >
          {this.state.resMessage}
        </Message>
        <Form
          noValidate
          autoComplete="off"
          className="manageNotificationIndiviNoti"
          id="manageNotificationIndiviNoti"
          onValidSubmit={this.onValidSubmitMember}
          style={{ marginBottom: "15px" }}
        >
          <div className="form-group" style={{ marginBottom: 10 }}>
            <label style={{ marginBottom: 0 }}>Name</label>
            <Form.Input
              type="text"
              className=""
              name="name"
              validations="isRequired"
              validationErrors={{
                isRequired: "This field is required.",
              }}
              errorLabel={errorLabel}
              onChange={this.onchangeenable}
              id="name_noti"
              defaultValue={this.state.modaldata.name}
            />
          </div>
          <div className="form-group" style={{ marginBottom: 10 }}>
            <label style={{ marginBottom: 0 }}>Email Address</label>
            <Form.Input
              type="email"
              className=""
              name="email"
              validations="isEmail,isRequired"
              validationErrors={{
                isEmail: "Please enter a valid email address.",
                isRequired: "This field is required.",
              }}
              errorLabel={errorLabel}
              onChange={this.onchangeenable}
              id="emailIndiviNoti"
              defaultValue={this.state.modaldata.email}
            />
          </div>

          <div
            className="form-group"
            style={{
              display: "flex",
              marginTop: 10,
              columnGap: 10,
              justifyContent: "right",
            }}
          >
            <button
              type="button"
              onClick={() => this.modalClose()}
              style={{
                display: this.state.modalbuttonmsg.cancel != "" ? "block" : "none",
              }}
              className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
              data-dismiss="modal"
            >
              <span>Close</span>
            </button>
            <button
              disabled={this.state.buttonDisable}
              type="submit"
              style={{
                display: this.state.modalbuttonmsg.submit != "" ? "block" : "none",
              }}
              className="btn linear-gradient yr-submitbtn btn-sm"
            >
              Submit
            </button>
          </div>
        </Form>
      </div>
    );
  };

  onValidSubmitMember = () => {
    this.setState({ loading: true, buttonDisable: true }, () => {
      this.setState({
        modalmessage: this.memberEditBody(),
      });
    });
    let pararam = { ...this.state.modaldata };
    api.manageUser
      .updatePerformanceAlertMember(pararam)
      .then((res) => {
        this.setState({ loading: false, buttonDisable: false }, () => {
          this.setState({
            modalmessage: this.memberEditBody(),
          });
        });
        if (res.data.status) {
          this.setState(
            {
              messageDisplay: "block",
              color: "green",
              resMessage: res.data.message,
            },
            () => {
              this.setState({
                modalmessage: this.memberEditBody(),
              });
            }
          );
        } else {
          this.setState(
            {
              messageDisplay: "block",
              color: "red",
              resMessage: res.data.message,
            },
            () => {
              this.setState({
                modalmessage: this.memberEditBody(),
              });
            }
          );
        }
        setTimeout(() => {
          this.setState(
            {
              messageDisplay: "none",
            },
            () => {
              this.setState({
                modalmessage: this.memberEditBody(),
              });
            }
          );
          if (res.data.error !== "duplicate" && res.data.status) {
            this.loadData({});
            this.modalClose();
          }
        }, 2000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  render() {
    return (
      <Segment>
        {this.state.loading && <div className="ui loading form"></div>}
        <DatatableFilter
          filter={this.state.q}
          totalCount={this.state.totalCount}
          onSubmitFilter={this.onSubmitFilter}
          loading={this.state.loading}
        />
        <DialogBoxDetail
          obj={this.state}
          show={this.state.modalstatus}
          title={this.state.modaltitle}
          modalType={this.state.modalType}
          modalClose={this.modalClose}
          buttonmsg={this.state.modalbuttonmsg}
          modalbuttofun={this.modalbuttofun}
          loading={this.state.loading}
          updateAction={this.state.updateAction}
        />
        <DatatableTable
          lists={this.state.lists}
          datatableHeader={tableHeader}
          datatableRows={this.state.datatableRows}
          totalCount={this.state.totalCount}
          totalPages={Math.ceil(this.state.totalCount / this.state._limit)}
          currentPage={this.state._page}
          onChangePage={this.onChangePage}
          column={this.state._sort}
          direction={DatatableList.directionConverter(this.state._order)}
          handleSort={this.handleSort}
          onChangeLimit={this.onChangeLimit}
          limit={this.state._limit.toString()}
        />
      </Segment>
    );
  }
}
